export default {
  'grafana': {
    width: 24,
    height: 24,
    d: 'M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 22c-5.523 0-10-4.477-10-10S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm4.5-13.5l-2.25 2.25.56 3.094c.094.469-.375.844-.844.656L12 13.125l-1.406.75c-.469.188-.938-.188-.844-.656l.563-3.094-2.25-2.25c-.375-.375-.188-1.031.375-1.125l3.093-.469 1.407-2.812c.187-.469.844-.469 1.03 0l1.407 2.813 3.094.468c.562.094.75.75.375 1.125z'
  }
}
